import React, { useState } from "react";
import data from "./data";
import SingleQuestion from "./Question";
import Question from "./Question";

function App() {
  return <Question />;
}

export default App;
